import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 12px 0;
  max-width: 400px;
`
